import { TouchableOpacity, View } from "react-native";
import { Text } from "react-native-paper";
import { documents, documentTypes } from "./constants";
import { getDocumentAsync, DocumentPickerAsset } from "expo-document-picker";
import { Controller, Control } from "react-hook-form";
import { JobApplyFormData } from "./types";
import NoDocumentSelected from "./NoDocumentSelected";
import DocumentSelected from "./DocumentSelected";
import config from "../../config";
import { useIntercom } from "../../hooks";

interface DocumentUploadProps {
  control: Control<JobApplyFormData>;
}

export default function DocumentUpload({ control }: DocumentUploadProps) {
  const handleSelectFile = (onChange: (value: DocumentPickerAsset) => void) => async () => {
    try {
      const result = await getDocumentAsync({ type: documentTypes });
      if (!result.canceled && result.assets.length > 0) onChange(result.assets[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const client = useIntercom();

  function learnToUpload() {
    client.present(config.intercomContent.jobsHowToUpload);
  }

  return (
    <View className="items-start py-6">
      <View className="px-6">
        <Text className="text-regular-tight font-700 text-ink-darkest mb-2">Resume and Cover Letter</Text>

        <Text className="text-small-normal font-400 text-ink-dark">
          Please upload your resume (required) and cover letter (optional).
        </Text>

        {__DEV__ && (
          <TouchableOpacity onPress={learnToUpload} className="py-6 w-auto">
            <Text className="text-primary underline text-link-small">Learn how to upload from iOS or Android.</Text>
          </TouchableOpacity>
        )}
      </View>
      <View className="divide-y divide-sky-light w-full">
        {documents.map(({ label, field, rules }) => (
          <View key={field}>
            <Controller
              name={field}
              control={control}
              rules={rules}
              render={({ field: { onChange, value }, fieldState: { error } }) =>
                value ? (
                  <DocumentSelected {...{ label, error, handleSelectFile, onChange, value }} />
                ) : (
                  <NoDocumentSelected {...{ label, error, handleSelectFile, onChange }} />
                )
              }
            />
          </View>
        ))}
      </View>
    </View>
  );
}
